<app-modal [isOpen]="isOpen" [showCloseButton]="false" (close)="onClose()" className="max-w-lg mx-4">
  <div class="p-6">
    <div class="mb-5 flex items-start gap-3">
      <span class="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-error-50 text-error-500 dark:bg-error-500/15">
        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m0 3.75h.007M10.34 3.94l-8.06 13.97A1.5 1.5 0 0 0 3.58 20.2h16.84a1.5 1.5 0 0 0 1.3-2.29L13.66 3.94a1.5 1.5 0 0 0-2.6 0Z" />
        </svg>
      </span>
      <div>
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Cancelar reunión</h3>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {{ meeting?.title }}
        </p>
      </div>
    </div>

    <div class="space-y-4">
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Motivo de cancelación <span class="text-error-500">*</span>
        </label>
        <select
          [(ngModel)]="selectedReasonId"
          [disabled]="loading || saving"
          class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-3 text-sm text-gray-800 focus:border-brand-300 focus:outline-none dark:border-gray-700 dark:text-white/90">
          <option [ngValue]="null" disabled>Seleccione un motivo…</option>
          @for (r of reasons; track r.id) {
            <option [ngValue]="r.id">{{ r.name }}</option>
          }
          <option [ngValue]="'other'">Otro (especificar)</option>
        </select>
      </div>

      @if (isOther) {
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Especifique el motivo <span class="text-error-500">*</span>
          </label>
          <textarea
            [(ngModel)]="customReason"
            [disabled]="saving"
            rows="3"
            placeholder="Describa el motivo de la cancelación…"
            class="w-full rounded-lg border border-gray-300 bg-transparent px-3 py-2 text-sm text-gray-800 focus:border-brand-300 focus:outline-none dark:border-gray-700 dark:text-white/90"></textarea>
        </div>
      }
    </div>

    <div class="mt-6 flex justify-end gap-3">
      <button
        type="button"
        (click)="onClose()"
        [disabled]="saving"
        class="rounded-lg border border-gray-300 px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5">
        Volver
      </button>
      <button
        type="button"
        (click)="confirmar()"
        [disabled]="saving"
        class="rounded-lg bg-error-500 px-4 py-2.5 text-sm font-medium text-white hover:bg-error-600 disabled:opacity-50">
        {{ saving ? 'Cancelando…' : 'Cancelar reunión' }}
      </button>
    </div>
  </div>
</app-modal>
